<div class="image-viewer-host" [class.fill-container]="fillContainer()">
  @if (src(); as imageSrc) {
    @if (enableZoom()) {
      <div
        #zoom="appZoomable"
        appZoomable
        [disableTouchMove]="disableTouchMove()"
        [enableZoom]="enableZoom()"
        [enableWheelZoom]="false"
        [minScale]="0.5"
        [maxScale]="3.0"
        class="image-zoom-container"
        [class.grabbing]="zoom.isDragging()"
      >
        <app-zoom-control
          class="zoom-toolbar"
          [(zoomScale)]="zoom.zoomScale"
          [minScale]="0.5"
          [maxScale]="3.0"
          [showFullScreen]="true"
          (fullscreen)="openFullView($event)"
          (reset)="zoom.resetZoom()"
          (click)="$event.stopPropagation()"
        />

        <div
          class="image-zoom-content"
          [style.transform]="'translate(' + zoom.panX() + 'px, ' + zoom.panY() + 'px) scale(' + zoom.zoomScale() + ')'"
          [style.transition]="zoom.isDragging() ? 'none' : 'transform 0.2s ease-out'"
        >
          <img [src]="imageSrc" [alt]="alt()" [style.border-radius]="borderRadius()" [style.object-fit]="objectFit()" />
        </div>
      </div>
    } @else {
      <img [src]="imageSrc" [alt]="alt()" [style.border-radius]="borderRadius()" [style.object-fit]="objectFit()" />

      <button mat-icon-button class="zoom-btn" (click)="openFullView($event)">
        <mat-icon>open_in_full</mat-icon>
      </button>
    }
  }
</div>
